import type { ReactNativeOptions, captureException } from "@sentry/react-native";
import type { SeverityLevel } from "@sentry/types";
import { applicationId } from "expo-application";
import { Platform } from "react-native";
import { sentryInstance } from "./instance";

let disableSentry = true;
export const initSentry = ({
  apiUrl: _apiUrl,
  ...options
}: ReactNativeOptions & { apiUrl?: string }) => {
  if (options.dsn) {
    try {
      sentryInstance.init({
        ...options,
        debug: false,
        environment:
          applicationId?.includes("beta") ||
          (Platform.OS === "web" && window?.location?.href?.includes?.("dev"))
            ? "staging"
            : __DEV__
              ? "development"
              : "production",
        ignoreErrors: ["Failed to register user. We already have a registered user."],
      });

      disableSentry = false;
    } catch {
      console.error("No Sentry DSN provided");
    }
  }
};

export const addSentryBreadcrumb = (
  message: string,
  {
    data,
    level = "debug",
    category,
  }: { data?: ToDo; level?: SeverityLevel; category?: string } = {},
) => {
  if (disableSentry) return;

  sentryInstance.addBreadcrumb({
    data: { data: JSON.stringify(data || {}) },
    level,
    category,
    message,
  });
};

export const captureSentryException = (
  message: string,
  exceptionContext: Parameters<typeof captureException>[1],
) => {
  if (disableSentry) return;

  sentryInstance.captureException(new Error(message), exceptionContext);
};

export const setSentryUser = (user: ToDo) => {
  if (disableSentry) return;

  sentryInstance.setUser(user);
};
